import {
  DownloadOutlined,
  DownOutlined,
  LoadingOutlined,
  ShoppingCartOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, Menu } from 'antd';
import clsx from 'clsx';
import styles from '../Style/DatasetInfo.module.scss';

export function DatasetActionButtons(props: {
  id: string;
  addedToCart: boolean;
  addToCart: () => void;
  removeFromCart: () => void;
  cartLoading: boolean;
  hasDatasets: boolean;
  disabled: boolean;
  onSwitchToDownload?: () => void;
  showDropdown?: boolean;
}) {
  const menu = (
    <Menu
      onClick={({ key }) => {
        if (key === 'download' && props.onSwitchToDownload) {
          props.onSwitchToDownload();
        }
      }}
    >
      <Menu.Item key='download' icon={<DownloadOutlined />}>
        Download
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {props.addedToCart ? (
        <Button
          type='primary'
          className={clsx(styles.CartButton, styles.removeButton)}
          onClick={props.removeFromCart}
          loading={props.cartLoading}
          disabled={!props.hasDatasets}
          id='PointPanel_Remove_Button'
        >
          Remove
        </Button>
      ) : (
        <div className={styles.cartButtonWrapper}>
          <Button
            id={`PointPanel-AddToCart_Button_${props.id}`}
            data-testid='PointPanel-AddToCart_Button'
            type='primary'
            className={clsx(
              styles.CartButton,
              props.showDropdown && styles.cartButton_withDropdown
            )}
            onClick={props.addToCart}
            disabled={!props.hasDatasets || props.disabled}
            icon={
              props.cartLoading && !props.showDropdown ? (
                <LoadingOutlined
                  spin={props.cartLoading}
                  style={{ marginRight: '5px' }}
                />
              ) : (
                <ShoppingCartOutlined
                  style={{ fontSize: '12px', flexShrink: 0 }}
                />
              )
            }
          >
            Add to Cart
          </Button>

          {props.showDropdown && (
            <Dropdown
              overlay={menu}
              trigger={['click']}
              disabled={props.disabled}
              placement='bottomRight'
            >
              <Button
                type='primary'
                icon={<DownOutlined />}
                className={styles.dropdownButton}
                disabled={!props.hasDatasets || props.disabled}
                loading={props.cartLoading}
              />
            </Dropdown>
          )}
        </div>
      )}
    </>
  );
}

export function DownloadButton(props: {
  showCancelDownloadButton: boolean;
  startDownloadProcess: () => void;
  disableDownloadButtons: boolean;
  handleCancelDownload: () => void;
  id: string;
  onSwitchToBuy?: () => void;
  showDropdown?: boolean;
}) {
  const menu = (
    <Menu
      onClick={({ key }) => {
        if (key === 'buy' && props.onSwitchToBuy) {
          props.onSwitchToBuy();
        }
      }}
    >
      <Menu.Item key='buy' icon={<ShoppingCartOutlined />}>
        Add to Cart
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {!props.showCancelDownloadButton ? (
        <div className={styles.downloadButtonContainer}>
          <Button
            id={`PointPanel-Download_Button_${props.id}`}
            type='primary'
            className={styles.CartButton}
            onClick={() => props.startDownloadProcess()}
            disabled={props.disableDownloadButtons}
            icon={<DownloadOutlined style={{ marginRight: 0 }} />}
          >
            <span className={styles.downloadButtonText}>Download</span>
          </Button>

          <Dropdown
            overlay={menu}
            trigger={['click']}
            disabled={props.disableDownloadButtons}
            placement='bottomRight'
          >
            <Button
              type='primary'
              icon={<DownOutlined />}
              className={styles.dropdownButton}
              disabled={props.disableDownloadButtons}
            />
          </Dropdown>
        </div>
      ) : (
        <Button
          type='primary'
          danger
          icon={<LoadingOutlined />}
          className={clsx(styles.CartButton, styles.cancelButton)}
          onClick={() => props.handleCancelDownload()}
        >
          Cancel
        </Button>
      )}
    </>
  );
}
